import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BackendApiService } from '../../services/backend-api.service';
import { ProjectSummary, ProjectBranding } from '../../models/api-dto.model';

export interface BrandingDialogData {
  project: ProjectSummary;
}

@Component({
  selector: 'app-branding-dialog',
  templateUrl: './branding-dialog.component.html',
  styleUrls: ['./branding-dialog.component.scss'],
  standalone: false
})
export class BrandingDialogComponent {
  portalTitle: string = '';
  portalBgColor: string = '#0f172a';
  portalTextColor: string = '#ffffff';
  portalPrimaryColor: string = '#3b82f6';

  isSubmitting: boolean = false;
  errorMessage: string = '';

  constructor(
    public dialogRef: MatDialogRef<BrandingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BrandingDialogData,
    private backendApi: BackendApiService,
    private snackBar: MatSnackBar
  ) {
    const branding = data?.project?.branding;
    this.portalTitle = branding?.portalTitle || (data?.project?.name ? `${data.project.name} Support Portal` : '');
    this.portalBgColor = branding?.portalBgColor || '#0f172a';
    this.portalTextColor = branding?.portalTextColor || '#ffffff';
    this.portalPrimaryColor = branding?.portalPrimaryColor || '#3b82f6';
  }

  onSubmit(): void {
    if (this.isSubmitting) return;

    this.isSubmitting = true;
    this.errorMessage = '';

    const branding: ProjectBranding = {
      portalTitle: this.portalTitle.trim(),
      portalBgColor: this.portalBgColor,
      portalTextColor: this.portalTextColor,
      portalPrimaryColor: this.portalPrimaryColor
    };

    this.backendApi.updateProject(this.data.project.id, { branding }).subscribe({
      next: (updated) => {
        this.isSubmitting = false;
        this.dialogRef.close(updated);
        this.snackBar.open('Support Portal branding updated successfully.', 'Close', { duration: 3000 });
      },
      error: (err) => {
        this.isSubmitting = false;
        this.errorMessage = err?.error?.message || 'Failed to update branding. Please try again.';
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
